module.exports = __webpack_public_path__ + "img/infobgimg.7afded29.png";